module.exports = __webpack_public_path__ + "static/media/arrow-down.07e7527d.svg";